import { combineReducers } from "redux";

import viewOperationReducer from "./viewOperationReducer";

export default combineReducers({
  viewOperation: viewOperationReducer
});
